module.exports = "<div class=\"chat-container hide\"> <div class=\"loading-tip hide\"> <span class=\"icon-spin loading-btn\"></span> <span> <%=msg_in_loading%></span> </div> <div class=\"no-more-msg hide\"> <span><%=no_more_msg%></span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/template/chatContainer.html
// module id = 232
// module chunks = 0